import { useState } from "react";
import type {
  AdMedia,
  CreativeChoice,
} from "src/pages/ad-studio/insights/performance/types";
import type {
  EntityCardAction,
  EntityCardMedia,
} from "src/pages/ad-studio/insights/performance/view/types";
import { useAdCardItemActions } from "src/pages/ad-studio/insights/performance/view/use-ad-card-item-actions";
import { toEntityCardMedia } from "src/pages/ad-studio/insights/performance/view/utils";

/** Where one ad card's media carousel is; each card keeps its own while it is mounted. */
export function useAdCardItem({ media }: { media: AdMedia }): {
  state: { media: EntityCardMedia };
  performAction: (action: EntityCardAction) => void;
} {
  const [choice, setChoice] = useState<CreativeChoice>({
    kind: "first-creative",
  });
  const performAction = useAdCardItemActions({ setChoice });
  return {
    state: { media: toEntityCardMedia({ media, choice }) },
    performAction,
  };
}
